import React, {useEffect, useState} from 'react';
import useAuth from "../../hooks/useAuth";
import {fillNamesOfSumDays, getAllProducts, getAllProductsGlobal, getTimeSlotMap} from "./common";
import {Box, Card, CardContent, CircularProgress, useMediaQuery} from "@mui/material";
import ApexChart from "react-apexcharts";
import {formatEurPriceAndRoundUtil} from "../../utils/currencyUtil";
import {getFilterMoment} from "../../utils/DateUtil";
import EuroIcon from "@mui/icons-material/Euro";
import localStrings from "../../localStrings";
import StackStatPresenter from "../../components/StackStatPresenter";
import DualPeriodComparison from "../../components/DualPeriodComparison";
import moment from "moment";
import {executeQueryUtil} from "../../utils/gqlUtil";
import {getSumUpDayQuery} from "../../gql/SumUpDayGql";
import {getSumUpWeekQuery} from "../../gql/SumUpWeekGql";
import {getSumUpMonthQuery} from "../../gql/SumUpMonthGql";
import {filterWeek, filterMonth, filterSingleDay} from "../Home/FilterInfoOverview";
import {decompressFromBase64} from "../../utils/compressUtil";

function GenericSparkDataSpark({title, getterData,
                                   modeGraph,
                                   icon,
                                   backgroundColor,
                                   formatter, getterTotalSingleDay, getterTotalMultiDay,
                                   invertComparison = false
}) {
    const [sumUpDaysStructured, setSumUpDaysStructured] = useState(null);
    const [chartOptions, setChartOptions] = useState(null)
    const [totalData, setTotalData] = useState(0)
    const [previousPeriodData, setPreviousPeriodData] = useState(0)
    const [comparisonData, setComparisonData] = useState(null)
    // const [loading, setLoading] = useState(true);
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

    const {
        sumUpDays,
        categories,
        staffs,
        paymentModes,
        locations,
        products,
        optionLists,
        weatherDays,
        filter,
        currentEstablishment,
        currentBrand,
        loading,
    } = useAuth();


    useEffect(() => {
        if (!sumUpDays || sumUpDays.length === 0) {
            return;
        }
        if (!products || !staffs || !paymentModes || !locations || !categories) {
            return;
        }

        const structuredSumup = fillNamesOfSumDays(sumUpDays, staffs, locations,
            products, optionLists, paymentModes, categories);
        setSumUpDaysStructured(structuredSumup);

    }, [sumUpDays, products, staffs, paymentModes, locations, categories, optionLists])



    useEffect(() => {

            const fillData = async () => {
                // setLoading(true);
                if (!sumUpDaysStructured || !sumUpDays || !products || !staffs || !paymentModes || !locations || !categories) {
                    return;
                }
                try {

                    const res = await getApexChartData(
                        sumUpDaysStructured, weatherDays, filter
                    );

                    if (res) {
                        setChartOptions(res);
                    }

                } catch (e) {
                    console.error('Erreur lors de la récupération des données pour le graphique :', e);

                }
            }
            fillData();
        }
        , [sumUpDays, products, staffs, paymentModes, locations, categories, sumUpDaysStructured, filter])



    async function getApexChartData(sumUpDaysStructured, weatherDays, filter) {

        if (!filter) {
            return;
        }

        if (!sumUpDaysStructured || sumUpDaysStructured.length === 0) {
            return;
        }
        let totalData = 0;
        let data = [];
        let sortedSlots = [];
        if (filter?.filterType === "filterSingleDay") {

            let timeSlotMaps = await getTimeSlotMap(sumUpDaysStructured, currentEstablishment());
            sortedSlots = [...new Set(Object.keys(timeSlotMaps))].sort()

            sortedSlots.forEach((timeSlot) => {
                let allDetail = timeSlotMaps[timeSlot];
                const totalNbSeats = allDetail.reduce((sum, detail) => {
                    return sum + (getterData(detail) || 0);
                }, 0);
                data.push(totalNbSeats);
                totalData += totalNbSeats;
            })
            if (getterTotalSingleDay) {
                totalData = getterTotalSingleDay(sumUpDaysStructured) || 0;
            }
            setTotalData(totalData);

            // Calculate comparison for single day vs previous day, previous week, and previous month
            const loadComparisonData = async () => {
                try {
                    // Utilise l'utilitaire getFilterMoment pour une conversion cohérente
                    const currentDate = getFilterMoment(filter);
                    const previousDate = currentDate.clone().subtract(1, 'day').format('YYYY-MM-DD');
                    const previousWeekDate = currentDate.clone().subtract(7, 'days').format('YYYY-MM-DD');
                    const previousMonthDate = currentDate.clone().subtract(1, 'month').format('YYYY-MM-DD');

                    // Fetch all comparison data
                    const [previousDayResult, previousWeekResult, previousMonthResult] = await Promise.all([
                        executeQueryUtil(getSumUpDayQuery(currentBrand()?.id, currentEstablishment()?.id, previousDate)),
                        executeQueryUtil(getSumUpDayQuery(currentBrand()?.id, currentEstablishment()?.id, previousWeekDate)),
                        executeQueryUtil(getSumUpDayQuery(currentBrand()?.id, currentEstablishment()?.id, previousMonthDate))
                    ]);

                    const previousDayValue = previousDayResult?.data?.getSumUpDay
                        ? getterData(JSON.parse(previousDayResult.data.getSumUpDay.content)) || 0
                        : null;

                    const previousWeekValue = previousWeekResult?.data?.getSumUpDay
                        ? getterData(JSON.parse(previousWeekResult.data.getSumUpDay.content)) || 0
                        : null;

                    const previousMonthValue = previousMonthResult?.data?.getSumUpDay
                        ? getterData(JSON.parse(previousMonthResult.data.getSumUpDay.content)) || 0
                        : null;

                    setComparisonData({
                        current: totalData,
                        previousDay: previousDayValue,
                        previousWeek: previousWeekValue,
                        previousMonth: previousMonthValue,
                        currentDate: filter.singleDay
                    });
                } catch (error) {
                    // Error loading comparison data
                    console.error('Error loading comparison data:', error);
                    setComparisonData(null);
                }
            };

            if (currentBrand()?.id && currentEstablishment()?.id) {
                loadComparisonData();
            }
        }



        else {

            sortedSlots = sumUpDaysStructured.map((sumDay) => sumDay.date);
            for (const sumDay of sumUpDaysStructured) {

                data.push(getterData(sumDay) || 0);
                totalData += getterData(sumDay) || 0;
            }

            if (getterTotalMultiDay) {
                totalData = getterTotalMultiDay(sumUpDaysStructured) || 0;
            }
            setTotalData(totalData);

            // Load comparison data based on filter type
            const loadComparisonData = async () => {
                try {
                    if (filter?.filterType === filterWeek) {
                        // For week filter, compare with previous week and previous month same week
                        // Use the same format as TurnOverSpark.js
                        const getWeekKey = (dayMoment) => {
                            const weekStart = moment(dayMoment).startOf('isoWeek');
                            const isoWeekNumber = weekStart.isoWeek();
                            return `${weekStart.format('YYYY')}-W${String(isoWeekNumber).padStart(2, '0')}-${weekStart.format('DD-MM')}`;
                        };

                        // Utilise filter.singleDay au lieu de filter.startDate pour la cohérence
                        const filterMoment = getFilterMoment(filter);
                        const currentWeek = getWeekKey(filterMoment);
                        const previousWeek = getWeekKey(filterMoment.clone().subtract(1, 'week'));
                        const previousMonthWeek = getWeekKey(filterMoment.clone().subtract(1, 'month'));

                        const [previousWeekResult, previousMonthResult] = await Promise.all([
                            executeQueryUtil(getSumUpWeekQuery(currentBrand()?.id, currentEstablishment()?.id, previousWeek)),
                            executeQueryUtil(getSumUpWeekQuery(currentBrand()?.id, currentEstablishment()?.id, previousMonthWeek))
                        ]);

                        // Decode previousWeek data
                        let previousWeekContent = previousWeekResult?.data?.getSumUpWeek?.content;
                        previousWeekContent = previousWeekContent && decompressFromBase64(previousWeekContent);
                        const previousWeekParsed = previousWeekContent ? JSON.parse(previousWeekContent) : null;
                        const previousWeekTotal = previousWeekParsed ? getterData(previousWeekParsed) || null : null;

                        // Decode previousMonth data
                        let previousMonthContent = previousMonthResult?.data?.getSumUpWeek?.content;
                        previousMonthContent = previousMonthContent && decompressFromBase64(previousMonthContent);
                        const previousMonthParsed = previousMonthContent ? JSON.parse(previousMonthContent) : null;
                        const previousMonthTotal = previousMonthParsed ? getterData(previousMonthParsed) || null : null;

                        setComparisonData({
                            current: totalData,
                            previousWeek: previousWeekTotal,
                            previousMonth: previousMonthTotal,
                            currentDate: filter.singleDay
                        });

                    } else if (filter?.filterType === filterMonth) {
                        // For month filter, compare with previous month AND same month of previous year
                        const getMonthKey = (dayMoment) => {
                            const monthStart = moment(dayMoment).startOf('month');
                            const monthEnd = moment(dayMoment).endOf('month');
                            return `${monthStart.format('YYYY')}-M${monthStart.format('MM')}-${monthEnd.format('DD')}-${monthEnd.format('MM')}`;
                        };

                        // Utilise filter.singleDay au lieu de filter.startDate pour la cohérence
                        const filterMoment = getFilterMoment(filter);
                        const currentMonth = getMonthKey(filterMoment);
                        const previousMonth = getMonthKey(filterMoment.clone().subtract(1, 'month'));
                        const previousYearMonth = getMonthKey(filterMoment.clone().subtract(1, 'year'));

                        console.log('Month comparison:', {
                            current: currentMonth,
                            previousMonth: previousMonth,
                            previousYear: previousYearMonth,
                            brandId: currentBrand()?.id,
                            establishmentId: currentEstablishment()?.id
                        });

                        const [previousMonthResult, previousYearResult] = await Promise.all([
                            executeQueryUtil(getSumUpMonthQuery(currentBrand()?.id, currentEstablishment()?.id, previousMonth)),
                            executeQueryUtil(getSumUpMonthQuery(currentBrand()?.id, currentEstablishment()?.id, previousYearMonth))
                        ]);

                        console.log('Month results:', { previousMonthResult, previousYearResult });

                        // Decode previousMonth data
                        let previousMonthContent = previousMonthResult?.data?.getSumUpMonth?.content;
                        previousMonthContent = previousMonthContent && decompressFromBase64(previousMonthContent);
                        const previousMonthParsed = previousMonthContent ? JSON.parse(previousMonthContent) : null;
                        const previousMonthTotal = previousMonthParsed ? getterData(previousMonthParsed) || null : null;

                        // Decode previousYear data
                        let previousYearContent = previousYearResult?.data?.getSumUpMonth?.content;
                        previousYearContent = previousYearContent && decompressFromBase64(previousYearContent);
                        const previousYearParsed = previousYearContent ? JSON.parse(previousYearContent) : null;
                        const previousYearTotal = previousYearParsed ? getterData(previousYearParsed) || null : null;

                        setComparisonData({
                            current: totalData,
                            previousMonth: previousMonthTotal,
                            previousYear: previousYearTotal,
                            currentDate: filter.singleDay
                        });

                    } else {
                        // Fallback: Calculate previous period data for comparison
                        if (data.length > 1) {
                            const midPoint = Math.floor(data.length / 2);
                            const currentPeriod = data.slice(midPoint).reduce((a, b) => a + b, 0);
                            const previousPeriod = data.slice(0, midPoint).reduce((a, b) => a + b, 0);

                            setComparisonData({
                                current: currentPeriod,
                                previous: previousPeriod
                            });
                        }
                    }
                } catch (error) {
                    console.error('Error loading comparison data:', error);
                    setComparisonData(null);
                }
            };

            if (currentBrand()?.id && currentEstablishment()?.id) {
                loadComparisonData();
            }
        }



// 🔁 Résultat à retourner
        return {
            series: [
                {
                    name: title,
                    data, // Ex: [125.3, 88.0, 142.5, ...]
                },
            ],
            options: {
                chart: {
                    id: 'sparkline-turnover',
                    type: 'area',
                    height: 260,
                    sparkline: {
                        enabled: false, // Disable sparkline to show x-axis
                    },
                    toolbar: {
                        show: false
                    }
                },
                stroke: {
                    curve: 'straight',
                    width: 2,
                },
                fill: {
                    opacity: 0.3,
                },
                dataLabels: {
                    enabled: false
                },
                grid: {
                    show: false, // Hide grid lines
                },
                yaxis: {
                    min: 0,
                    labels: {
                        show: false, // Keep Y axis hidden
                    },
                },
                xaxis: {
                    type: "category",
                    categories: sortedSlots, // Ex: ["08:00", "09:00", ...]
                    labels: {
                        show: true,
                        rotate: -45,
                        rotateAlways: true,
                        style: {
                            fontSize: '11px'
                        },
                        hideOverlappingLabels: true,
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                labels: sortedSlots,
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return formatter ? formatter(val, lgUp) : val
                            //return formatEurPriceAndRoundUtil(val, lgUp); // Affichage € correctement
                        },
                    },
                    x: {
                        formatter: function (val, opts) {
                            const isIndex = typeof val === 'number' && sortedSlots[val];
                            return isIndex ? sortedSlots[val] : val;
                        }
                    }
                },
                colors: ['#DCE6EC'],
                title: {
                    text: formatter ? formatter(totalData, lgUp) : totalData,
                    offsetX: 30,
                    style: {
                        fontSize: '24px',
                        cssClass: 'apexcharts-yaxis-title',
                    },
                },
                subtitle: {
                    text: title,
                    offsetX: 30,
                    style: {
                        fontSize: '14px',
                        cssClass: 'apexcharts-yaxis-title',
                    },
                }
            }
        };

    }

    return (
        <Card sx={{margin: 0, padding: 0}}>
            {/*<p>{loading ? "Y" : "N"}</p>*/}
            <CardContent sx={{margin: 0, padding: 0, paddingBottom: "0 !important"}}>
                {!loading ?
                    <>
                        {sumUpDaysStructured && sumUpDaysStructured.length > 0 && chartOptions  &&
                            <>
                                {modeGraph ?
                                    <>
                                        {comparisonData && (
                                            <DualPeriodComparison
                                                currentValue={comparisonData.current}
                                                previousDayValue={comparisonData.previousDay}
                                                previousWeekValue={comparisonData.previousWeek}
                                                previousMonthValue={comparisonData.previousMonth}
                                                previousYearValue={comparisonData.previousYear}
                                                currentDate={comparisonData.currentDate}
                                                formatter={formatter ? (val) => formatter(val, lgUp) : null}
                                                invertColors={invertComparison}
                                            />
                                        )}
                                        <ApexChart
                                            options={chartOptions.options}
                                            series={chartOptions.series}
                                            type={chartOptions.options?.chart?.type}
                                            height={300}
                                        />
                                    </>
                                    :
                                    <>
                                        {comparisonData && (
                                            <DualPeriodComparison
                                                currentValue={comparisonData.current}
                                                previousDayValue={comparisonData.previousDay}
                                                previousWeekValue={comparisonData.previousWeek}
                                                previousMonthValue={comparisonData.previousMonth}
                                                previousYearValue={comparisonData.previousYear}
                                                currentDate={comparisonData.currentDate}
                                                formatter={formatter ? (val) => formatter(val, lgUp) : null}
                                                invertColors={invertComparison}
                                            />
                                        )}
                                        <StackStatPresenter
                                            backgroundColor={backgroundColor}
                                            icon={icon}
                                            value={ formatter ? formatter(totalData, lgUp) : totalData}
                                            label={title}
                                        />
                                    </>
                                }
                            </>
                        }
                    </>
                    :
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '350px'
                    }}>
                        <CircularProgress size="100px" />
                    </Box>
                }
            </CardContent>
        </Card>
    )
}

export default GenericSparkDataSpark